import React from 'react';

const features = [
  { title: 'Live Leaderboard', desc: 'Real-time digital scoring for all guests', icon: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14l-4-4 1.41-1.41L11 13.17l6.59-6.59L19 8l-8 8z' },
  { title: 'Event-Ready', desc: 'Perfect for corporate & private events', icon: 'M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-2V2h-2v2H7zm12 4v2H5V8h14z' },
  { title: 'Multi-Lane Setup', desc: 'Scale from 1 to multiple lanes', icon: 'M7 4V2H5v2H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-2V2h-2v2H7zm12 4v2H5V8h14z' },
  { title: 'Professional Kit', desc: 'LED lighting, quality turf surface', icon: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' },
];

export default function About() {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-grid">
          <div className="about-img-wrap">
            <img src="/images/2grrensandscreens.png" alt="RushPutt Lanes" />
            <div className="about-img-badge">LED-lit<br />Putting Lane</div>
          </div>

          <div className="about-text">
            <p className="section-label">What is RushPutt?</p>
            <h2 className="section-title">Golf Meets <span>Gaming</span></h2>
            <p>
              RushPutt is a fully interactive, competitive putting experience that transforms
              any venue into a golf gaming zone. With professional LED-lit lanes, live digital
              scoring, and a real-time leaderboard, it's the perfect centrepiece for any event.
            </p>
            <p>
              Whether you're hosting a corporate away day, a birthday party, or a golf event,
              RushPutt creates instant competition and keeps your guests coming back for more.
            </p>
            <div className="features-list">
              {features.map((f) => (
                <div className="feature-item" key={f.title}>
                  <div className="feature-icon">
                    <svg viewBox="0 0 24 24"><path d={f.icon} /></svg>
                  </div>
                  <div>
                    <strong>{f.title}</strong>
                    <span>{f.desc}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
